<div class="hdis-player-time" #time></div>
